import {InputText, Select} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBdName, FormItemBdNo} from '../BD/FormChooseBd.jsx'
import Model from './ModelBdsummary.mjs'
import StoryType from './StoryType.jsx'

export const FormItemAlgTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="algTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemStoryType = props => (
    <FormItemBizProp
        Model={Model}
        prop="storyType"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={StoryType}
        />
    </FormItemBizProp>
)

export default function FormChooseBdsummary(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemBdNo />
            <FormItemBdName />
            <FormItemAlgTitle />
            <FormItemStoryType />
        </FormChooseDesign>
    )
}
